import classNames from "classnames";
import { usePathname, useSearchParams } from "next/navigation";
import { parse } from "qs";

import toggleURLSearchParamValue from "@/utils/toggleURLSearchParamValue";

import Checkbox from "@/components/botanic/Checkbox";

export const FULFILLMENT_METHODS = [
  { name: "Pickup", value: "pickup" },
  { name: "Delivery", value: "delivery" },
  { name: "Direct Shipping", value: "shipping" },
];
export const FULFILLMENT_LABEL_MAP = FULFILLMENT_METHODS.reduce<
  Record<string, string>
>((labelMap, { name, value }) => ({ ...labelMap, [value]: name }), {});

const FulfillmentFilters = ({
  sectionPadding,
}: {
  sectionPadding?: string;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const query = parse(searchParams?.toString() || "");
  const selectedFulfillment = Array.isArray(query.fulfillment)
    ? (query.fulfillment as string[])
    : [];

  const targetURLSearchParams = new URLSearchParams(searchParams?.toString());
  // * Remove pagination params when clicking fulfillment filter link.
  targetURLSearchParams.delete("page");

  return (
    <div
      className={classNames(
        "py-md md:border-t border-light-grey",
        sectionPadding,
      )}
    >
      {FULFILLMENT_METHODS.map((fulfillment) => (
        <Checkbox
          id={fulfillment.value}
          key={fulfillment.value}
          disabled={false}
          data-testid={`_${fulfillment.value}`}
          href={{
            pathname,
            query: toggleURLSearchParamValue(
              targetURLSearchParams,
              "fulfillment",
              fulfillment.value,
              { forceArray: true },
            ).toString(),
          }}
          checked={
            Array.isArray(selectedFulfillment) &&
            (selectedFulfillment as string[]).includes(fulfillment.value)
          }
          className="px-xs py-md"
          value={fulfillment.value}
        >
          {fulfillment.name}
        </Checkbox>
      ))}
    </div>
  );
};

export default FulfillmentFilters;
